export type ShopifyCartAddFailureReason = 'out_of_stock' | 'rejected'

export function classifyShopifyCartAddFailure(body: unknown): ShopifyCartAddFailureReason {
  const text = extractShopifyCartAddErrorText(body)?.toLowerCase() ?? ''
  const mentionsSoldOut = text.includes('sold out') || text.includes('out of stock')

  if (mentionsSoldOut) {
    return 'out_of_stock'
  }

  return 'rejected'
}

function extractShopifyCartAddErrorText(body: unknown): string | null {
  if (!body || typeof body !== 'object') return null

  const record = body as Record<string, unknown>
  const parts: string[] = []

  if (typeof record.message === 'string') parts.push(record.message)
  if (typeof record.description === 'string') parts.push(record.description)

  return parts.length > 0 ? parts.join(' ') : null
}
